<template>
  <page-outline
    class="page"
    :title="$t('Webheader.rtp_global_settings')"
    colWidth="6"
  >
    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <b-row v-if="canSeeSRTP">
          <b-col cols="12" lg="10" offset="1" class="mb-3">
            <form-write-group-label-input
              v-model="settings.RTPSPIdentifier" :disabled="!doesEdit"
              inputType="text"
              :inputLabel="$t('administration.rtp_identifier')"
              horizontal>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row v-if="canSeeSRTP">
          <b-col cols="12" lg="10" offset="1" class="mb-3">
            <form-write-group-label-input
              v-model="settings['SRTP-RTPSPMaxAmount']" :disabled="!doesEdit"
              :maxLength="21"
              class="justify-content-around"
              inputType="number"
              :inputLabel="$t('settings.max_amnt_srtp')"
              horizontal
              @blur="changeMaxAmountSRTP">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row v-if="canSeeSRTP">
          <b-col cols="12" lg="10" offset="1" class="mb-3">
            <form-write-group-label-input
              v-model="settings.RTPSPTimeBeforeExpiration" :disabled="!doesEdit"
              :maxLength="21"
              inputType="number"
              :inputLabel="$t('administration.rtp_time_before_expiration')"
              horizontal
              @blur="changeTimeBeforeExpSRTP">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row v-if="canSeeHRTP">
          <b-col cols="12" lg="10" offset="1" class="mb-3">
            <form-write-group-label-input
              v-model="settings['HRTP-Identifier']" :disabled="!doesEdit"
              inputType="text"
              :inputLabel="$t('administration.hrtp_identifier')"
              horizontal>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row v-if="canSeeHRTP">
          <b-col cols="12" lg="10" offset="1" class="mb-3">
            <form-write-group-label-input
              v-model="settings['HRTP-RTPSPMaxAmount']" :disabled="!doesEdit"
              :maxLength="21"
              class="justify-content-around"
              inputType="number"
              :inputLabel="$t('settings.max_amnt_hrtp')"
              horizontal
              @blur="changeMaxAmountHRTP">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row v-if="canSeeHRTP">
          <b-col cols="12" lg="10" offset="1" class="mb-3">
            <form-write-group-label-input
              v-model="settings['HRTP-ValidityPeriod']" :disabled="!doesEdit"
              :maxLength="21"
              inputType="text"
              :inputLabel="$t('administration.rtp_h_validity_period')"
              horizontal
              @blur="changeVldityPeriodHRTP">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </div>
        <div class="col-md-10 offset-md-1" v-if="hasRight('application_global_rtp_settings_editer')">
          <b-row class="justify-content-end no-gutters" v-if="!doesEdit">
            <b-button @click="editSettings" variant="primary">
              <span>{{ $t("administration.edit") }}</span>
            </b-button>
          </b-row>
          <b-row v-else class="justify-content-end no-gutters">
            <div>
              <b-button @click="resetSettings" variant="primary">
                <span>{{ $t("common.cncl") }}</span>
              </b-button>
            </div>
            <div class="pl-3">
              <b-button @click="updateSettings(settings)" variant="primary">
                <span>{{ $t("common.update") }}</span>
              </b-button>
            </div>
          </b-row>
        </div>
    </template>
  </page-outline>
</template>
<script>
import PageOutline from "@/components/common/PageOutline.vue"
import FormAccordion from "@/components/common/FormAccordion.vue"
import Spinner from "@/components/common/spinner.vue"
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import formReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import { errorMessageAlert } from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'

export default {
  name: "RTPSettings",
  components: {
    "page-outline": PageOutline,
    "form-accordion": FormAccordion,
    spinner: Spinner,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "form-read-group-label-input": formReadGroupLabelInput,
  },
  data() {
    return {
      activateSpinner: false,
      doesEdit: false,
      originalSettings: {},
      settings: {
        RTPSPIdentifier: '',
        RTPSPTimeBeforeExpiration: '',
        'SRTP-RTPSPMaxAmount': '',
        'HRTP-RTPSPMaxAmount': '',
        'HRTP-ValidityPeriod': ''

      },
    }
  },
  computed: {
    canSeeSRTP () {
      return this.$engine.rights.rightIs('rtp_norm_srtp', true)
    },
    canSeeHRTP () {
      return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
    }
  },
  created() {
    this.getSettings()
  },
  methods: {
    changeMaxAmountHRTP() {
      if(this.settings['HRTP-RTPSPMaxAmount']) {
        if (this.settings['HRTP-RTPSPMaxAmount'].includes('e')) {
          this.settings['HRTP-RTPSPMaxAmount'] = parseFloat(this.settings['HRTP-RTPSPMaxAmount'].split('e')[0]) * Math.pow(10, parseInt(this.settings['HRTP-RTPSPMaxAmount'].split('e')[1]))
        }
        if(this.settings['HRTP-RTPSPMaxAmount'].length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings['HRTP-RTPSPMaxAmount'].slice(this.settings['HRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings['HRTP-RTPSPMaxAmount'].split('.')[0]
          this.settings['HRTP-RTPSPMaxAmount'] = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings['HRTP-RTPSPMaxAmount'] = parseFloat(this.settings['HRTP-RTPSPMaxAmount']).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeMaxAmountSRTP() {
      if(this.settings['SRTP-RTPSPMaxAmount']) {
        if (this.settings['SRTP-RTPSPMaxAmount'].includes('e')) {
          this.settings['SRTP-RTPSPMaxAmount'] = parseFloat(this.settings['SRTP-RTPSPMaxAmount'].split('e')[0]) * Math.pow(10, parseInt(this.settings['SRTP-RTPSPMaxAmount'].split('e')[1]))
        }
        if(this.settings['SRTP-RTPSPMaxAmount'].length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings['SRTP-RTPSPMaxAmount'].slice(this.settings['SRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings['SRTP-RTPSPMaxAmount'].split('.')[0]
          this.settings['SRTP-RTPSPMaxAmount'] = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings['SRTP-RTPSPMaxAmount'] = parseFloat(this.settings['SRTP-RTPSPMaxAmount']).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeTimeBeforeExpSRTP() {
      if(this.settings.RTPSPTimeBeforeExpiration) {
        if(this.settings.RTPSPTimeBeforeExpiration.length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings.RTPSPTimeBeforeExpiration.slice(this.settings.RTPSPTimeBeforeExpiration.indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings.RTPSPTimeBeforeExpiration.split('.')[0]
          this.settings.RTPSPTimeBeforeExpiration = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings.RTPSPTimeBeforeExpiration = parseInt(this.settings.RTPSPTimeBeforeExpiration, 10).toString()
        }
      } else {
        return
      }
    },
    changeVldityPeriodHRTP() {
      if(this.settings['HRTP-ValidityPeriod']) {
        if(this.settings['HRTP-ValidityPeriod'].length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings['HRTP-ValidityPeriod'].slice(this.settings['HRTP-ValidityPeriod'].indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings['HRTP-ValidityPeriod'].split('.')[0]
          this.settings['HRTP-ValidityPeriod'] = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings['HRTP-ValidityPeriod'] = parseInt(this.settings['HRTP-ValidityPeriod'], 10).toString()
        }
      } else {
        return
      }
    },
    getSettings() {
      this.activateSpinner = true
      this.$engine.services.payments.fetchGlobalSettings().then((resp) => {
        this.settings.RTPSPIdentifier = resp.data.GlobalRTPSettings.RTPSPIdentifier
        this.settings['HRTP-Identifier'] = resp.data.GlobalRTPSettings['HRTP-Identifier']
        this.settings['SRTP-RTPSPMaxAmount'] = resp.data.GlobalRTPSettings['SRTP-RTPSPMaxAmount']
        this.settings['HRTP-RTPSPMaxAmount'] = resp.data.GlobalRTPSettings['HRTP-RTPSPMaxAmount']
        this.settings['HRTP-ValidityPeriod'] = resp.data.GlobalRTPSettings['HRTP-ValidityPeriod']
        this.settings.RTPSPTimeBeforeExpiration = resp.data.GlobalRTPSettings.RTPSPTimeBeforeExpiration
        this.activateSpinner = false
        this.originalSettings = Object.assign({}, this.settings)
      })
    },
    editSettings() {
      this.doesEdit = true
    },
    hasRight(right) {
      return this.$engine.rights.rightIs(right, true)
    },
    resetSettings () {
      this.getSettings()
      this.doesEdit = false
    },
    updateSettings(settings) {
      let that = this

      if (!this.settings.RTPSPIdentifier) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_identifier')}))
        return
      }
      if (!this.settings['SRTP-RTPSPMaxAmount']) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_amnt_srtp')}))
        return
      }
      if (!this.settings.RTPSPTimeBeforeExpiration) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_time_before_expiration')}))
        return
      }
      if (!this.settings['HRTP-Identifier']) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.hrtp_identifier')}))
        return
      }
      if (!this.settings['HRTP-RTPSPMaxAmount']) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_amnt_hrtp')}))
        return
      }
      if (!this.settings['HRTP-ValidityPeriod']) {
        this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_h_validity_period')}))
        return
      }

      this.doesEdit = false
      let array = []
      let changedSettings = {}

      Object.keys(settings).forEach((key) => {
        if (settings[key] !== this.originalSettings[key]) {
          changedSettings[key] = settings[key]
        }
      })
      this.originalSettings = Object.assign({}, settings)
      Object.entries(changedSettings).forEach((element) => {
        let object = {}
        object = {
          name: element[0],
          value: element[1],
        }
        array.push(object)
      })

      let data = array
      this.$engine.services.payments
        .updateGlobalSettings({ data })
        .then((resp) => {
          that.$f7.modal({
            title: that.$i18n.t("Paramètre(s) modifié(s)"),
            buttons: [
              {
                text: "OK",
                onClick: function () {
                  return
                },
              },
            ],
          })
          loadPage(that, { url: "/settings/rtpSettings/" })
        })
        .catch((e) => {
          errorMessageAlert(e, that)
          that.$f7.modal({
            title: that.$i18n.t(
              "Erreur lors de la modification des paramètres"
            ),
            buttons: [
              {
                text: "OK",
                onClick: function () {
                  return
                },
              },
            ],
          })
        })
    },
  },
}
</script>
